import { createFileRoute } from "@tanstack/react-router";

import { RoutePage, routeEntry } from "./routeTable";

const entry = routeEntry("/auth/callback");

/**
 * Where the identity provider sends the browser back (AU-D13). Outside `AppShell`, like `/login`
 * and `/select-tenant`: there is no tenant yet, and choosing one is part of what happens here.
 */
export const Route = createFileRoute("/auth/callback")({
  head: () => ({
    meta: [
      { title: "Signing in — LevelLoad" },
      { name: "description", content: "Signing in — LevelLoad transport planning." },
    ],
  }),
  component: RouteComponent,
});

function RouteComponent() {
  return <RoutePage entry={entry} />;
}
